export default "__VITE_ASSET__CqH_stt5__"